export { default as ProductsIndexTableRowSimilarSearchButton } from './ProductsIndexTableRowSimilarSearchButton';
